import React, { useEffect, useState } from 'react';
import { Form, Button, Radio } from 'antd';

import Layout from './layout';
import Query from '../../../util/query';
import Global from '../../../util/global';
import StudentFormItem from './StudentFormItem';
import TeacherFormItem from './TeacherFormItem';
import AdvisorFormItem from './AdvisorFormItem';
import RangeDateFormItem from './RangeDateFormItem';
import BrForForm from './BrForForm';

const FormItem = Form.Item;

const FilterForm = (props) => {
  const [form] = Form.useForm();
  const {
    fetchStudentList,
    studentList,
    teacherList,
    fetchTeacherList,
    advisorList,
    fetchAdvisorList,
    search,
    pagination,
    isTeacher,
    currentTeacherId,
    showStudent = true,
    showAdvisor = true,
    onQueryChange,
  } = props;

  const [radioValue, setRadioValue] = useState(Global.thisMonth);

  const notifyQueryChange = (values) => {
    if (onQueryChange) {
      onQueryChange(Query.constructQueryForTransaction(values));
    }
  };

  const getFormValues = () => {
    const values = form.getFieldsValue();
    const student_id = form.getFieldValue('student_id');
    const teacher = form.getFieldValue('teacher');
    return {
      ...values,
      ...(student_id ? { student_id } : {}),
      ...(teacher ? { teacher } : {}),
    };
  };

  useEffect(() => {
    if (isTeacher && currentTeacherId) {
      form.setFieldsValue({ teacher: currentTeacherId });
    }
  }, [currentTeacherId, form, isTeacher]);

  function getQuery() {
    if (isTeacher && currentTeacherId) {
      form.setFieldsValue({ teacher: currentTeacherId });
    }
    const values = getFormValues();
    if (!values.rangeDatePick) {
      form.setFieldsValue({ rangeDatePick: Global.thisMonth });
    }
    const currentValues = getFormValues();
    console.log('get query', currentValues);
    let query = Query.constructQueryForTransaction(currentValues);
    // console.log('query in filter form is: ', query);
    return query;
  }

  function query() {
    let query = getQuery();
    notifyQueryChange(getFormValues());
    search(pagination.current, pagination.pageSize, query);
  }

  function handleSizeChange(e) {
    console.log('handleSizeChange: ', e);
    const nextValues = {
      ...getFormValues(),
      rangeDatePick: e.target.value,
    };
    form.setFieldsValue({ rangeDatePick: e.target.value });
    setRadioValue(e.target.value);
    let query = Query.constructQueryForTransaction(nextValues);
    notifyQueryChange(nextValues);
    search(pagination.current, pagination.pageSize, query);
  }

  function reset() {
    console.log('reset: ', form.getFieldValue());
    form.resetFields();
    form.setFieldsValue({
      rangeDatePick: [],
      ...(isTeacher && currentTeacherId ? { teacher: currentTeacherId } : {}),
    });
    setRadioValue(null);
  }

  return (
    <Form
      layout='inline'
      form={form}
      initialValues={{ rangeDatePick: Global.thisMonth }}
      onValuesChange={(changedValues, allValues) => {
        if (changedValues.rangeDatePick || changedValues.teacher) {
          notifyQueryChange(allValues);
        }
      }}
    >
      {showStudent && (
        <StudentFormItem
          formItemLayout={{}}
          rules={[]}
          form={form}
          fetchStudentList={fetchStudentList}
          studentList={studentList}
          // itemStyle={Layout.filterInputStyle}
          autoCompleteStyle={Layout.autoCompleteStyle}
        />
      )}
      <TeacherFormItem
        formItemLayout={{}}
        rules={[]}
        form={form}
        teacherList={teacherList}
        fetchTeacherList={fetchTeacherList}
        itemStyle={Layout.filterInputStyle}
        label='试听老师'
      />
      {showAdvisor && (
        <AdvisorFormItem
          formItemLayout={{}}
          rules={[]}
          form={form}
          advisorList={advisorList}
          fetchAdvisorList={fetchAdvisorList}
          itemStyle={Layout.filterInputStyle}
        />
      )}
      <BrForForm />
      <RangeDateFormItem
        form={form}
        setRadioValue={setRadioValue}
        onRangeDateChange={(dates) => {
          notifyQueryChange({
            ...getFormValues(),
            rangeDatePick: dates,
          });
        }}
      />
      <BrForForm />
      <FormItem>
        <Radio.Group value={radioValue} onChange={(e) => handleSizeChange(e)}>
          <Radio.Button value={Global.today}>今日</Radio.Button>
          <Radio.Button value={Global.lastMonth}>上月</Radio.Button>
          <Radio.Button value={Global.thisMonth}>本月</Radio.Button>
          <Radio.Button value={Global.last90}>季度</Radio.Button>
          <Radio.Button value={Global.thisYear}>本年</Radio.Button>
          <Radio.Button value={Global.all}>全部</Radio.Button>
        </Radio.Group>
        <Button type='primary' style={{ margin: '0 20px' }} onClick={query}>
          查询
        </Button>
        <Button onClick={reset}>重置</Button>
      </FormItem>
    </Form>
  );
};

export default FilterForm;
